/* global Turbo */

function urlFromIdAndAction (base, entityId, action, params) {
  let url = `/${base}`
  if (entityId !== undefined) {
    url += `/${entityId}`
  }
  if (action !== undefined) {
    url += `/${action}`
  }
  if (params !== undefined) {
    url += '?' + Object.keys(params).map(k => `${k}=${params[k]}`).join('&')
  }
  return url
}

export function url ({ entityType, entityId, action, params }) {
  const lowerEntityType = entityType.toLowerCase()
  const lowerAction = action === undefined ? undefined : action.toLowerCase()

  if (lowerEntityType === 'business') {
    return urlFromIdAndAction('employers', entityId, lowerAction, params)
  } else if (lowerEntityType === 'job') {
    return urlFromIdAndAction('jobs', entityId, lowerAction, params)
  } else if (lowerEntityType === 'assignment') {
    return urlFromIdAndAction('assignments', entityId, lowerAction, params)
  } else if (lowerEntityType === 'event') {
    return urlFromIdAndAction('events', entityId, lowerAction, params)
  } else if (lowerEntityType === 'estimate') {
    return urlFromIdAndAction('estimates', entityId, lowerAction, params)
  } else if (lowerEntityType === 'invoice') {
    return urlFromIdAndAction('invoices', entityId, lowerAction, params)
  } else if (lowerEntityType === 'attachment') {
    return urlFromIdAndAction('attachments', entityId, lowerAction, params)
  } else if (lowerEntityType === 'user') {
    return urlFromIdAndAction('users', entityId, lowerAction, params)
  } else if (lowerEntityType === 'agency') {
    return urlFromIdAndAction('agencies', entityId, lowerAction, params)
  } else if (lowerEntityType === 'virtual_bank_account') {
    return urlFromIdAndAction('virtual_bank_accounts', entityId, lowerAction, params)
  } else if (lowerEntityType === 'audit_event') {
    return urlFromIdAndAction('audit_logs/Event', entityId, 'all', params)
  } else if (lowerEntityType === 'audit_job') {
    return urlFromIdAndAction('audit_logs/Job', entityId, 'related_to', params)
  } else {
    console.error(`${entityType} does not have a known url.`)
  }
}

/**
 * @deprecated use the openUrl function instead
 */
export function goToUrl ({ entityType, entityId, action, params }, newTab = false) {
  if (newTab) {
    window.open(url({ entityType, entityId, action, params }))
  } else {
    Turbo.visit(url({ entityType, entityId, action, params }))
  }
}

export function openUrl (url, newTab) {
  if (newTab) {
    window.open(url)
  } else {
    Turbo.visit(url)
  }
}

export function emailUrl (email) {
  const cleanEmail = email.replace(' ', '')
  return `mailto:${cleanEmail}`
}

export function phoneUrl (phoneNumber) {
  const cleanNumber = phoneNumber.replace(' ', '').replace('(', '').replace(')', '').replace('-', '').replace('+', '')

  let formattedNumber

  if (cleanNumber.length < 10) {
    console.error('Phone numbers must include area code.', phoneNumber)
  } else if (cleanNumber.length === 10) {
    const seg1 = cleanNumber.slice(0, 3)
    const seg2 = cleanNumber.slice(3, 6)
    const seg3 = cleanNumber.slice(6, 10)
    formattedNumber = `+1-${seg1}-${seg2}-${seg3}`
  } else if (cleanNumber.length === 11) {
    const seg1 = cleanNumber.slice(0, 1)
    const seg2 = cleanNumber.slice(1, 4)
    const seg3 = cleanNumber.slice(4, 7)
    const seg4 = cleanNumber.slice(7, 11)
    formattedNumber = `+${seg1}-${seg2}-${seg3}-${seg4}`
  }

  return `tel:${formattedNumber}`
}

export function mapUrl (address) {
  const applePlatformStrings = ['iPhone', 'iPad', 'iPod']

  let protocol = ''
  if (applePlatformStrings.some(str => navigator.platform.indexOf(str) !== -1)) {
    protocol = 'maps'
  } else {
    protocol = 'https'
  }

  return `${protocol}://maps.google.com?q=${address}`
}
